import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/loyalties', request)
}

export {get}
